import {GestionClienteState} from '../interfaces/gestion-cliente.interface'

export const gestionClienteInitialState: GestionClienteState = {
  listarClientes: {
    arrayClientes: [],
    clientes: [],
    formBuscar: {
      nombre: '',
      email: '',
      telefono: '',
      numId: '',
      tipoDocumento: '',
    },
    clienteSeleccionado: null,
    modales: {
      activeEliminar: false,
      activeEstatus: false,
    },
  },
  editarCliente: {
    formCliente: {},
    errorsFormCliente: {},
    clienteSeleccionado: null,
  },
  agregarCliente: {
    clientesFileDataCargada: [],
  },
}
